import { createFileRoute } from "@tanstack/react-router";
import { LegalPage, legalHead } from "@/pages/LegalPage";
import { cookiepolitikStrings } from "@/i18n/content/legal";

export const Route = createFileRoute("/cookie-og-privatlivspolitik")({
  head: () => legalHead("cookiepolitik", "da", cookiepolitikStrings.da.meta),
  component: () => <LegalPage {...cookiepolitikStrings.da} />,
});
